import $ from 'jquery';

var coordinates = {
    'up-left': [-1, -2],
    'up-center': [0, -2],
    'up-right': [1, -2],
    'down-left': [-1, 2],
    'down-center': [0, 2],
    'down-right': [1, 2],
    'left-top': [-6, -1],
    'left-middle': [-6, 0],
    'left-bottom': [-6, 1],
    'right-top': [6, -1],
    'right-middle': [6, 0],
    'right-bottom': [6, 1],
    'up-fluid': [0, -15],
    'down-fluid': [0, 15]
};

var locations = {};
var Tooltip = function() {};

Tooltip.prototype.init = function(options, elem) {
    this.elem = elem;
    this.$elem = $(elem);

    for (var prop in coordinates) {
        locations[prop] = {
            'direction'  : prop.split('-')[0],
            'alignment'  : prop.split('-')[1],
            'coordinate' : coordinates[prop]
        };
    }

    this.options = options;

    this.$tooltip = this._build(this.$elem);

    this._bindEvents(options, this.$elem, this.$tooltip);

    return this;
};

Tooltip.prototype.show = function($elem, $tooltip, options) {
    var that = this;

    // update the tooltip content when needed
    that.update($elem, $tooltip);

    $('body').append($tooltip);

    that._applyVariations($tooltip, options);

    // bind close action (used for onload)
    $tooltip.on('click', function tooltipEndClick() {
        that.hide($tooltip);
    });

    // Required for positioning detection
    $tooltip.css('visibility', 'visible');

    that._setLocation($elem, $tooltip, options);

    // set to active
    $tooltip.attr('data-tooltip-state', 'active');
};

Tooltip.prototype.hide = function($tooltip) {
    $tooltip.attr('data-tooltip-state', 'inactive');
    $tooltip.off('click');

    // Manually removed due to it being manually added for position detection
    $tooltip.css('visibility', 'hidden');
};

Tooltip.prototype._setLocation = function($elem, $tooltip, options) {
    var that = this;

    var orderedLocations = Object.keys(locations).sort(function(a, b) {
        return that._getDistanceSquared(a, options.location) -
            that._getDistanceSquared(b, options.location);
    });

    orderedLocations.every(function(locationName) {
        that._positionToolTip($elem, $tooltip, locationName, options.spacing);
        return that._isOffPage($tooltip);
    });
};

Tooltip.prototype._applyVariations = function($tooltip, options) {
   $tooltip.addClass(options.variations.split(' ').map(function(item, i) {

        // sanitise `tooltip--` prefixes on variations
        return 'tooltip--' + item.replace(/^tooltip--/, '');
    }).join(' '));
};

Tooltip.prototype._getDistanceSquared = function(locationNameA, locationNameB) {
    var locationA = locations[locationNameA];
    var locationB = locations[locationNameB];

    // Distance squared is ok for sorting.
    return Math.pow(locationA.coordinate[0] - locationB.coordinate[0], 2) +
        Math.pow(locationA.coordinate[1] - locationB.coordinate[1], 2);
};

Tooltip.prototype.update = function($elem, $tooltip) {
    var $content = {};

    // if this is html tooltip
    if ($elem.attr('data-tooltip-content') !== undefined) {
        $content = $($elem.attr('data-tooltip-content'));

        if ($content.length > 0) {
            $tooltip.find('[data-tooltip-content]').html($content.first().clone().removeAttr('data-hidden'));
        }
    }
    else {
        var title = $elem.attr('title');

        if (typeof title !== "undefined") {
            $tooltip.attr('data-tooltip-title', title);
            $tooltip.find('[data-tooltip-content]').text(title);
            $elem.removeAttr('title');
        }
    }
};

Tooltip.prototype._build = function($elem) {
    var that = this;
    var $tooltip;
    var $tooltipWrapper;
    var $tooltipContent;
    var $tooltipTip;

    $tooltipWrapper = $('<div>', {
        'class': 'tooltip',
        'data-tooltip-title': ''
    });

    $tooltipContent = $('<div>', {
        'class': 'tooltip__content',
        'data-tooltip-content': ''
    });

    $tooltipTip = $('<span>', {
        'class': 'tooltip__tip',
        'data-tooltip-tip': true
    });

    $tooltip = $tooltipWrapper.html($tooltipContent).prepend($tooltipTip);

    // update the tooltip content
    that.update($elem, $tooltip);

    return $tooltip;
};

Tooltip.prototype._bindEvents = function(options, $elem, $tooltip) {
    var that = this;

    $elem
        .on(options.show, function tooltipStart() {
            that.show($elem, $tooltip, options);
        })
        .on('mouseleave', function() {
            that.hide($tooltip);
        })
        .on('touchstart', function tooltipStart() {
            var isActive = $tooltip.attr('data-tooltip-state') === 'active';

            // Toggle active state on touch devices
            if (isActive) {
                that.hide($tooltip);
            } else {
                that.show($elem, $tooltip, options);
            }
        });
};

Tooltip.prototype._positionToolTip = function($elem, $tooltip, locationName, distance) {
    var that = this;
    var location = locations[locationName];

    that._resetPositioning($tooltip);

    $tooltip.attr('data-tooltip-location', locationName || '');

    // Setting to current width as wrapping occurs on right edge
    if (location.alignment !== 'fluid') {

        // Round up width up and add 1px to prevent edge case wrapping
        var width = Math.ceil($tooltip[0].getBoundingClientRect().width) + 1;
        $tooltip.css('width', width);
    }

    $tooltip.css(that._calcOffset($elem, $tooltip, location, distance));

    // Recalculate in case of wrapping
    if (location.direction === 'up') {
        $tooltip.css(that._calcOffset($elem, $tooltip, location, distance));
    }

    $tooltip.find('[data-tooltip-tip]').css(that._calcTipOffset($elem, $tooltip, location));
};

Tooltip.prototype._resetPositioning = function($tooltip) {
    $tooltip.attr('data-tooltip-location', '');
    $tooltip.css({'top': '', 'left': '', 'width': ''});
    $tooltip.find('[data-tooltip-tip]').css({'top': '', 'left': ''});
};

Tooltip.prototype._calcOffset = function($elem, $tooltip, location, distance) {
    var elemRect = $elem[0].getBoundingClientRect();
    var tooltipRect = $tooltip[0].getBoundingClientRect();
    var scrollTop = $(window).scrollTop();
    var position = {};

    switch (location.direction) {
        case 'up':
            position.top = elemRect.top + scrollTop - distance - tooltipRect.height;
            break;
        case 'down':
            position.top = elemRect.top + scrollTop + distance + elemRect.height;
            break;
        case 'left':
            position.left = elemRect.left - distance - tooltipRect.width;
            break;
        case 'right':
            position.left = elemRect.left + distance + elemRect.width;
            break;
    }

    if (location.alignment !== 'fluid') {
        switch (location.alignment) {
            case 'left':
                position.left = elemRect.left;
                break;
            case 'center':
                position.left = elemRect.left + (elemRect.width / 2) - (tooltipRect.width / 2);
                break;
            case 'right':
                position.left = elemRect.left + elemRect.width - tooltipRect.width;
                break;
            case 'top':
                position.top = elemRect.top + scrollTop;
                break;
            case 'middle':
                position.top = elemRect.top + scrollTop + (elemRect.height / 2) - (tooltipRect.height / 2);
                break;
            case 'bottom':
                position.top = elemRect.top + scrollTop + (elemRect.height - tooltipRect.height);
                break;
        }
    }

    return position;
};

Tooltip.prototype._calcTipOffset = function($elem, $tooltip, location) {
    var elemRect = $elem[0].getBoundingClientRect();
    var tooltipRect = $tooltip[0].getBoundingClientRect();
    var scrollTop = $(window).scrollTop();
    var position = {};

    if (location.alignment !== 'fluid') {
        switch (location.alignment) {
            case 'top':
                position.top = (elemRect.height > tooltipRect.height) ? '50%' : elemRect.height / 2;
                break;
            case 'middle':
                position.top = '50%';
                break;
            case 'bottom':
                position.top = (elemRect.height > tooltipRect.height) ? '50%' : (elemRect.height / 2) + (tooltipRect.height / 2);
                break;

            case 'left':
                position.left = (elemRect.width > tooltipRect.width) ? '50%' : elemRect.width / 2;
                break;
            case 'center':
                position.left = '50%';
                break;
            case 'right':
                position.left = (elemRect.width > tooltipRect.width) ? '50%' : tooltipRect.width - (elemRect.width / 2);
                break;
        }
    } else {
        position.left = (elemRect.left + (elemRect.width / 2)) - tooltipRect.left;
    }

    return position;
};

Tooltip.prototype._isOffPage = function($tooltip) {
    var tRect = $tooltip[0].getBoundingClientRect();
    var isOffScreen = tRect.right > $(window).width() ||   // overflow right?
        tRect.bottom > $(window).height() ||               // overflow bottom?
        tRect.left < 0 ||                                  // overflow left?
        tRect.top < 0;                                     // overflow top?

    return isOffScreen;
};

export default Tooltip;



// WEBPACK FOOTER //
// ./~/@99designs/asimov/tooltip/lib/tooltip.js